import type { UserProfileData } from '@/shared/schemas/meApi.schema'

export const COOKIE_PREFERENCES_EVENT = 'cse:open-cookie-preferences'

// SEC-G5 (CNIL): consent lapses after 13 months and must be re-asked.
const CONSENT_MAX_AGE_DAYS = 396

export type CookieConsent = {
  version: 1
  analytics: boolean
  functional: boolean
  marketing: boolean
  /** ISO timestamp of the choice - drives the 13-month CNIL expiry (SEC-G5). */
  consentedAt: string
}

function isExpired(consentedAt: string | undefined): boolean {
  if (!consentedAt) {
    return true
  }
  const consentedAtMs = new Date(consentedAt).getTime()
  if (Number.isNaN(consentedAtMs)) {
    return true
  }
  const ageDays = (Date.now() - consentedAtMs) / (1000 * 60 * 60 * 24)

  return ageDays > CONSENT_MAX_AGE_DAYS
}

export function cookieConsentFromProfile(profile: UserProfileData | undefined): CookieConsent | null {
  const consent = profile?.cookie_consent
  if (consent == null || isExpired(consent.consented_at)) {
    return null
  }

  return {
    version: 1,
    analytics: consent.analytics,
    functional: consent.functional,
    marketing: consent.marketing ?? false,
    consentedAt: consent.consented_at,
  }
}

/** Re-open the cookie preferences dialog (footer / legal page). */
export function openCookiePreferences(): void {
  window.dispatchEvent(new CustomEvent(COOKIE_PREFERENCES_EVENT))
}

export function dispatchCookieConsentChanged(consent: CookieConsent): void {
  window.dispatchEvent(new CustomEvent('cse:cookie-consent-changed', { detail: consent }))
}
